/* istanbul ignore file */
import { EvaluatedFieldsProperties } from '../../../../models';
import { ReportView } from '../../../../models/report-view-model';
import { Field } from '../field';
import { GridColumnProperties } from '../grid-column-properties';
import { ReportSiteData } from './report-site-data';

export class Report {
    name?: string;
    reportDefinitionId?: string;
    selectedFields?: Field[] = [];
    reportData?: ReportSiteData[] = [];
    columnSettings: GridColumnProperties[] = [];
    customViews: ReportView[] = [];
    evaluatedFieldsProperties: Map<string, EvaluatedFieldsProperties> = new Map<string, EvaluatedFieldsProperties>();
    enableSubRow = false;
}
